import React from 'react';
const UserProfileBadge = ({ currentUser, userPlan, isDarkMode }) => {
  if (!currentUser) return null;

  const getPlanColor = (planName) => {
    if (planName === 'free') return isDarkMode ? 'bg-gray-700 text-gray-300' : 'bg-gray-200 text-gray-700';
    if (planName === 'monthly') return isDarkMode ? 'bg-blue-700 text-blue-200' : 'bg-blue-100 text-blue-700';
    if (planName === 'yearly') return isDarkMode ? 'bg-purple-700 text-purple-200' : 'bg-purple-100 text-purple-700';
    return isDarkMode ? 'bg-gray-700 text-gray-300' : 'bg-gray-200 text-gray-700';
  };

  return (
    <div className={`flex items-center gap-2 text-xs ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
      <span className="font-medium">{currentUser.full_name}</span>
      {userPlan && (
        <span className={`px-2 py-0.5 rounded-full font-medium ${getPlanColor(userPlan.name)}`}>
          {userPlan.display_name}
        </span>
      )}
    </div>
  );
};


// User Profile Component - Display Plan and Usage

export default UserProfileBadge;
